import { useEffect, useState } from "react";
import { Wrapper } from "./split-buy.style";
import { Link } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Label,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import {
  FiPlus,
  FiSearch,
  FiFilter,
  FiMoreVertical,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiUsers,
  FiX,
  FiCheckCircle,
  FiClock,
  FiPackage,
  FiShoppingBag,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import { AdminBreadcrumbs } from "../../../../components/adminBreadcrumbs";

// Shaped to match the real /split-buy detail response
const splitBuys = [
  {
    id: "6a6d87f853a9c3aa8271844a",
    product: { title: "Cow Meat" },
    split_cost_per_slot: 31500,
    number_of_buy_ins_required: 32,
    fractional_number_of_buy_ins_attained: 0,
    number_of_splitters: 0,
    join_period_end_date: "2026-08-26T14:00:00.000Z",
    split_buy_status: "approved",
  },
  {
    id: "5f2c11e0a1b2c3d4e5f6a7b8",
    product: { title: "NPK Fertilizer (25kg)" },
    split_cost_per_slot: 8200,
    number_of_buy_ins_required: 100,
    fractional_number_of_buy_ins_attained: 100,
    number_of_splitters: 61,
    join_period_end_date: "2026-07-28T14:00:00.000Z",
    split_buy_status: "completed",
  },
  {
    id: "9d3e22f1b2c3d4e5f6a7b8c9",
    product: { title: "Rice Paddy (100kg)" },
    split_cost_per_slot: 42000,
    number_of_buy_ins_required: 60,
    fractional_number_of_buy_ins_attained: 22,
    number_of_splitters: 12,
    join_period_end_date: "2026-08-20T14:00:00.000Z",
    split_buy_status: "pending",
  },
  {
    id: "1a2b3c4d5e6f7a8b9c0d1e2f",
    product: { title: "Cassava Cuttings (bundle)" },
    split_cost_per_slot: 1500,
    number_of_buy_ins_required: 300,
    fractional_number_of_buy_ins_attained: 96,
    number_of_splitters: 18,
    join_period_end_date: "2026-07-15T14:00:00.000Z",
    split_buy_status: "expired",
  },
  {
    id: "3c4d5e6f7a8b9c0d1e2f3a4b",
    product: { title: "Palm Oil (20L)" },
    split_cost_per_slot: 18500,
    number_of_buy_ins_required: 80,
    fractional_number_of_buy_ins_attained: 80,
    number_of_splitters: 45,
    join_period_end_date: "2026-07-05T14:00:00.000Z",
    split_buy_status: "completed",
  },
  {
    id: "7e8f9a0b1c2d3e4f5a6b7c8d",
    product: { title: "Goat Meat (Full)" },
    split_cost_per_slot: 22000,
    number_of_buy_ins_required: 20,
    fractional_number_of_buy_ins_attained: 5,
    number_of_splitters: 5,
    join_period_end_date: "2026-08-30T14:00:00.000Z",
    split_buy_status: "approved",
  },
  {
    id: "0b1c2d3e4f5a6b7c8d9e0f1a",
    product: { title: "Yam Tubers (Crate)" },
    split_cost_per_slot: 4500,
    number_of_buy_ins_required: 50,
    fractional_number_of_buy_ins_attained: 0,
    number_of_splitters: 0,
    join_period_end_date: "2026-06-30T14:00:00.000Z",
    split_buy_status: "rejected",
  },
];

const statusOptions = ["approved", "pending", "completed", "expired", "rejected"];

const currency = (n) =>
  n.toLocaleString("en-NG", { style: "currency", currency: "NGN", maximumFractionDigits: 0 });

const formatDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

const formatStatus = (status) => status.charAt(0).toUpperCase() + status.slice(1);

const statusTone = (status) => status === "approved" ? "approved" : status === "completed" ? "completed" : status === "pending" ? "pending" : "danger";

function RowActionsDropdown({ deal }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen((prev) => !prev)}>
      <DropdownToggle
        tag="button"
        aria-label={`Actions for split-buy ${deal.id}`}
        className="row-action-button"
      >
        <FiMoreVertical size={16} />
      </DropdownToggle>
      <DropdownMenu end className="deal-action-menu">
        <DropdownItem tag={Link} to={`/admin/internal/resources/split-buy/${deal.id}`} className="deal-action-item">
          <FiEye size={14} /> View deal
        </DropdownItem>
        <DropdownItem tag={Link} to={`/admin/internal/resources/split-buy/${deal.id}?tab=edit`} className="deal-action-item">
          <FiEdit2 size={14} /> Edit deal
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem className="deal-action-item danger">
          <FiTrash2 size={14} /> Cancel deal
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

const defaultFilters = {
  statuses: [],
  minParticipants: "",
  minProgress: "",
};

const PAGE_SIZE = 5;

export const SplitBuy = () => {
  const [query, setQuery] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [draftFilters, setDraftFilters] = useState(defaultFilters);
  const [page, setPage] = useState(1);

  const openFilters = () => {
    setDraftFilters(filters);
    setIsFilterOpen(true);
  };
  const closeFilters = () => setIsFilterOpen(false);

  const toggleDraftStatus = (status) => {
    setDraftFilters((prev) => ({
      ...prev,
      statuses: prev.statuses.includes(status)
        ? prev.statuses.filter((s) => s !== status)
        : [...prev.statuses, status],
    }));
  };

  const applyFilters = () => {
    setFilters(draftFilters);
    closeFilters();
  };

  const clearFilters = () => {
    setDraftFilters(defaultFilters);
    setFilters(defaultFilters);
  };

  const activeFilterCount =
    filters.statuses.length + (filters.minParticipants ? 1 : 0) + (filters.minProgress ? 1 : 0);

  const filtered = splitBuys.filter((d) => {
    const matchesQuery =
      d.product.title.toLowerCase().includes(query.toLowerCase()) ||
      d.id.toLowerCase().includes(query.toLowerCase());

    const matchesStatus = filters.statuses.length === 0 || filters.statuses.includes(d.split_buy_status);

    const matchesParticipants =
      !filters.minParticipants || d.number_of_splitters >= Number(filters.minParticipants);

    const pct = Math.round((d.fractional_number_of_buy_ins_attained / d.number_of_buy_ins_required) * 100);
    const matchesProgress = !filters.minProgress || pct >= Number(filters.minProgress);

    return matchesQuery && matchesStatus && matchesParticipants && matchesProgress;
  });

  useEffect(() => {
    setPage(1);
  }, [query, filters]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const paginated = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  const allSelected = selectedIds.size > 0 && selectedIds.size === paginated.length;
  const someSelected = selectedIds.size > 0 && !allSelected;

  const toggleAll = () => {
    setSelectedIds(allSelected ? new Set() : new Set(paginated.map((d) => d.id)));
  };

  const toggleRow = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const summaryCards = [
    {
      label: "All campaigns",
      value: splitBuys.length,
      note: "Across every status",
      icon: FiPackage,
      color: "green",
    },
    {
      label: "Active deals",
      value: splitBuys.filter((d) => d.split_buy_status === "approved").length,
      note: "Open for participation",
      icon: FiCheckCircle,
      color: "blue",
    },
    {
      label: "Total participants",
      value: splitBuys.reduce((sum, d) => sum + d.number_of_splitters, 0),
      note: "Across all campaigns",
      icon: FiUsers,
      color: "amber",
    },
    {
      label: "Completed",
      value: splitBuys.filter((d) => d.split_buy_status === "completed").length,
      note: "Ready for fulfilment",
      icon: FiShoppingBag,
      color: "green",
    },
  ];

  return (
    <Wrapper>
      <div className="split-buy-page">
        <AdminBreadcrumbs />
        <header className="page-heading">
          <div><span className="page-eyebrow">Procurement workspace</span><h1>Split-Buy campaigns</h1><p>Monitor participation, manage deal configuration and move completed campaigns into fulfilment.</p></div>
          <button type="button" className="new-deal-button"><FiPlus aria-hidden="true" /> New Split-Buy</button>
        </header>

        <section className="summary-strip" aria-label="Split-Buy summary">
          {summaryCards.map(({ label, value, note, icon: Icon, color }) => (
            <article className={`summary-card ${color}`} key={label}>
              <span className="summary-icon"><Icon aria-hidden="true" /></span>
              <div><span>{label}</span><strong>{value}</strong><small>{note}</small></div>
            </article>
          ))}
        </section>

        <section className="campaign-surface">
          <header className="list-toolbar">
            <div className="list-title"><h2>All campaigns</h2><p>{selectedIds.size > 0 ? `${selectedIds.size} campaign${selectedIds.size === 1 ? "" : "s"} selected` : `${filtered.length} of ${splitBuys.length} campaigns`}</p></div>
            <div className="list-controls">
              <label className="deal-search"><FiSearch aria-hidden="true" /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search product or campaign ID" aria-label="Search split-buy campaigns" /></label>
              <button type="button" onClick={openFilters} className={`filter-button ${activeFilterCount ? "active" : ""}`}><FiFilter aria-hidden="true" /> Filters{activeFilterCount > 0 && <span>{activeFilterCount}</span>}</button>
            </div>
          </header>

          {selectedIds.size > 0 && <div className="selection-banner"><FiCheckCircle aria-hidden="true" /><span><strong>{selectedIds.size} selected.</strong> Choose an action from each campaign menu.</span><button type="button" onClick={() => setSelectedIds(new Set())}>Clear selection</button></div>}

          <div className="deal-table-wrap">
            <table className="deal-table">
              <thead>
                <tr>
                  <th className="selection-cell"><input type="checkbox" aria-label="Select all campaigns on this page" checked={allSelected} ref={(element) => element && (element.indeterminate = someSelected)} onChange={toggleAll} /></th>
                  <th>Product & campaign</th><th>Price per slot</th><th>Slot progress</th><th>Buyers</th><th>Join deadline</th><th>Status</th><th aria-label="Actions" />
                </tr>
              </thead>
              <tbody>
                {paginated.map((deal) => {
                  const pct = Math.round((deal.fractional_number_of_buy_ins_attained / deal.number_of_buy_ins_required) * 100);
                  return (
                    <tr key={deal.id} className={selectedIds.has(deal.id) ? "selected" : ""}>
                      <td className="selection-cell"><input type="checkbox" aria-label={`Select ${deal.product.title}`} checked={selectedIds.has(deal.id)} onChange={() => toggleRow(deal.id)} /></td>
                      <td data-label="Campaign"><Link className="product-cell" to={`/admin/internal/resources/split-buy/${deal.id}`}><span className="product-mark"><FiPackage aria-hidden="true" /></span><span><strong>{deal.product.title}</strong><small>#{deal.id.slice(-8).toUpperCase()}</small></span></Link></td>
                      <td data-label="Price per slot"><span className="money-cell">{currency(deal.split_cost_per_slot)}</span></td>
                      <td data-label="Slot progress"><div className="slot-progress"><div><span>{deal.fractional_number_of_buy_ins_attained} of {deal.number_of_buy_ins_required} slots</span><strong>{pct}%</strong></div><span className="progress-track"><span className={pct >= 100 ? "complete" : pct >= 50 ? "mid" : "early"} style={{ width: `${Math.min(pct, 100)}%` }} /></span></div></td>
                      <td data-label="Buyers"><span className="buyer-count"><FiUsers aria-hidden="true" /> {deal.number_of_splitters}</span></td>
                      <td data-label="Join deadline"><span className="deadline-cell"><FiClock aria-hidden="true" /> {formatDate(deal.join_period_end_date)}</span></td>
                      <td data-label="Status"><span className={`deal-status ${statusTone(deal.split_buy_status)}`}>{formatStatus(deal.split_buy_status)}</span></td>
                      <td className="actions-cell"><RowActionsDropdown deal={deal} /></td>
                    </tr>
                  );
                })}
                {paginated.length === 0 && (
                  <tr>
                    <td colSpan={8}><div className="empty-state"><FiSearch aria-hidden="true" /><strong>No matching campaigns</strong><span>Try changing your search or clearing the active filters.</span></div></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filtered.length > 0 && (
            <footer className="table-pagination">
              <p>
                Showing {(currentPage - 1) * PAGE_SIZE + 1}–{Math.min(currentPage * PAGE_SIZE, filtered.length)} of{" "}
                {filtered.length}
              </p>
              <Pagination className="pagination-list" listClassName="pagination-items">
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    previous
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    className="page-button"
                    aria-label="Previous page"
                  >
                    <FiChevronLeft size={14} />
                  </PaginationLink>
                </PaginationItem>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
                  <PaginationItem key={pageNum} active={pageNum === currentPage}>
                    <PaginationLink
                      onClick={() => setPage(pageNum)}
                      className="page-button"
                      aria-label={`Page ${pageNum}`}
                    >
                      {pageNum}
                    </PaginationLink>
                  </PaginationItem>
                ))}

                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    next
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    className="page-button"
                    aria-label="Next page"
                  >
                    <FiChevronRight size={14} />
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </footer>
          )}
        </section>

        {/* Filter drawer */}
        <Offcanvas isOpen={isFilterOpen} toggle={closeFilters} direction="end">
          <OffcanvasHeader toggle={closeFilters} className="tw-border-b tw-border-gray-100 tw-px-5 tw-py-4">
            Filter deals
          </OffcanvasHeader>
          <OffcanvasBody className="tw-flex tw-flex-col tw-gap-6 tw-px-5 tw-py-5">
            <div>
              <p className="tw-mb-2 tw-text-sm tw-font-semibold tw-text-gray-900">Status</p>
              <div className="tw-flex tw-flex-col tw-gap-2">
                {statusOptions.map((status) => (
                  <label key={status} className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-700">
                    <Input
                      type="checkbox"
                      checked={draftFilters.statuses.includes(status)}
                      onChange={() => toggleDraftStatus(status)}
                      className="tw-h-4 tw-w-4 tw-rounded tw-border-gray-300 tw-text-emerald-600 focus:tw-ring-emerald-500"
                    />
                    {formatStatus(status)}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <Label for="minParticipants" className="tw-mb-2 tw-block tw-text-sm tw-font-semibold tw-text-gray-900">
                Minimum participants
              </Label>
              <Input
                id="minParticipants"
                type="number"
                min="0"
                placeholder="e.g. 20"
                value={draftFilters.minParticipants}
                onChange={(e) => setDraftFilters((prev) => ({ ...prev, minParticipants: e.target.value }))}
                className="tw-rounded-lg tw-border-gray-200 tw-text-sm"
              />
            </div>

            <div>
              <Label for="minProgress" className="tw-mb-2 tw-block tw-text-sm tw-font-semibold tw-text-gray-900">
                Minimum progress (%)
              </Label>
              <Input
                id="minProgress"
                type="number"
                min="0"
                max="100"
                placeholder="e.g. 50"
                value={draftFilters.minProgress}
                onChange={(e) => setDraftFilters((prev) => ({ ...prev, minProgress: e.target.value }))}
                className="tw-rounded-lg tw-border-gray-200 tw-text-sm"
              />
            </div>

            <div className="tw-mt-auto tw-flex tw-gap-3 tw-border-t tw-border-gray-100 tw-pt-4">
              <Button
                outline
                onClick={clearFilters}
                className="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-2 tw-border-gray-200 tw-text-gray-600 hover:tw-bg-gray-50"
              >
                <FiX size={14} />
                Clear
              </Button>
              <Button
                onClick={applyFilters}
                className="tw-flex-1 tw-border-0 tw-bg-[var(--color-primary-dark)] tw-text-white hover:tw-brightness-110"
              >
                Apply filters
              </Button>
            </div>
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </Wrapper>
  );
};
